import { UnknownPageError } from './unknown_page_error'

const DEFAULT_PAGE_BY_ROLE = {
  participant: 'home',
  slideware: 'activities',
  presenter: 'activities',
  agave: 'activities',
  embed: 'blank',
  auth: 'please_wait',
  webex: 'presenter'
}

// Gets the default page for a role
export function getDefaultPage (role) {
  if (DEFAULT_PAGE_BY_ROLE[role]) {
    return DEFAULT_PAGE_BY_ROLE[role]
  }

  throw UnknownPageError(`No default page defined by role: ${role}`)
}
